// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import * as React from "react";


const ProductName: React.FC<HasProduct> = ({ product }) => {
    if (!product) {
        return null;
    }

    return (
        <div>
            <span>{product.productNumber}</span>
            {product.manufacturerItem && (
                <span>
                    {siteMessage("Custom_MFR_#", "MFR #:")}' {product.manufacturerItem}
                </span>
            )}
            {product.customerProductNumber && (
                <span>
                    {siteMessage("Custom_Your_Part_#", "Your Part #:")} {product.customerProductNumber}
                </span>
            )}
        </div>
    );
};

const productNameModule: WidgetModule = {
    component: withProduct(ProductName),
    definition: {
        group: "Products",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default productNameModule;
